import styled from "styled-components"
import { Modal } from 'react-bootstrap';

const RewardsDashboard = styled.div`
.top-cards{
    display: flex;
    flex-direction: row;
    gap: 25px;
}
`

const ConfigureRewards = styled.div`
height:${({height}) => height ? height : '365px'};
margin:${({margin}) => margin ? margin : '20px'};
width:100%;
${'' /* background:#DCDCDC; */}
${'' /* margin-top:20px; */}

border-radius: 12px;
${'' /* border: 1px solid #BE7D9C; */}
background-image: ${({ bg }) => (bg ? `url(${bg})` : 'none')};
background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
${'' /* background: #FAF5F8; */}

.content{
    display:flex;
    justify-content:center;
    ${'' /* margin-top:50px; */}
    ${'' /* margin:${({contentMargin}) => contentMargin ? contentMargin : '0'}; */}
    padding:${({contentPadding}) => contentPadding ? contentPadding : '0'};
    flex-direction:column;
    width:100%;
    align-items:center;
}

.text{
    color: #184A61;
text-align: center;
font-family: Lato;
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: 38px; 
}

.sub-text{
    color: #184A61;
text-align: center;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
${'' /* margin-top:12px;
margin-bottom:20px; */}
margin:${({subTextMargin}) => subTextMargin ? subTextMargin : '12px 0px 20px 0px'};
}
`




const StyledModal = styled(Modal)`
  .modal-dialog {
    top:8%;
    display:flex;
    justify-content:center;
  }
  .modal-content{
    width: ${({ width }) => width || '400px'} ;
    height: ${({ height }) => height};
    padding :${({ padding }) => padding || '16px'};
    border-radius:12px;
  }
  .modal-body{
    padding:0px;
    margin-top:20px;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
  }
  .footer{
    display:flex;
    margin-top:20px;
    justify-content:center;

  }
  .modal-content-padding {
}

@media (min-width: 576px){
      max-width:100%;
    }

    @media (min-width: 576px) {
    .modal-dialog {
        max-width: 100%;
        /* margin-right: auto; */
        /* margin-left: auto; */
    }
}
`;


const CalendarHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center; 
  justify-content: space-between;
  background: none;
  margin-bottom: 20px; 
  color: #184A61;
  font-family: 'Lato';
  font-size: 18px;
  font-weight: 700;

  .left-content {
    display: flex;
    align-items: center; 
    ${'' /* gap: 10px; */}

    .icon{
      display:flex;
      margin-right:12px;
    }
  }

  .close-icon {
    cursor: pointer;
    text-align: right;
  }

`;


const Border = styled.div`
border:${({isBorder}) => isBorder ? isBorder : '1px solid #EFEFEF'};
`;


const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  ${'' /* padding: 24px; */}
  border: 1px solid ${({ active }) => (active ? '#E85D5D' : '#DCDCDC')};
  display: flex;
  flex-direction: column;
  ${'' /* transition: 0.2s ease; */}
  border-radius: 12px;


  ${'' /* &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0,0,0,0.06);
  } */}

  .tier-body{
    padding:20px;
  }
`;



const Header = styled.div`
  display: flex;
  justify-content: center;
  ${'' /* margin-bottom: 12px; */}
  align-items:center;
  background:${({bg}) => bg ? bg : 'linear-gradient(90deg, rgba(231, 238, 248, 0.60) 0%, rgba(185, 200, 232, 0.60) 100%)'};
  height:53px;
`;

const Title = styled.span`
color: var(--Font-Color-on-Light-theme-500, #184A61);
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 36px;
`;

const Badge = styled.div`
  padding: 4px 12px;
  border-radius: 4px;
  background:${({bg}) => bg ? bg : '#8391D1'};

  color: #FEFEFE;
text-align: center;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
width:fit-content;
`;

const Description = styled.p`
  margin: 16px 0px
  
color:#184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
`;


const PointsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;

    color: #184A61;
        font-family: Lato;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; 

    .level{
        font-weight: 700;
    }

    svg {
      font-size: 16px;
      flex-shrink: 0;
    }
  }
`;

const TierBody = styled.div`
  margin: 12px 16px 0px 16px;
  flex: 1; /* THIS IS THE KEY */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items:center;
  width:100%;
  padding-bottom: 20px;
  margin-top: auto;  /* PUSHES IT DOWN */
`;

const CompanyMedalCardsSliderContainer = styled.div`
padding:${({totalPages}) => totalPages > 1 && '12px'}
border-radius: ${({totalPages}) => totalPages > 1 && '12px'}
border: ${({totalPages}) => totalPages > 1 && '1px solid #DCDCDC'} ;
background: ${({totalPages}) => totalPages > 1 && '#FEFEFE'} ;

.upcoming{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
margin-bottom:20px;
}

.heading{
    display:flex;
    justify-content:space-between;
    margin-bottom:20px;
}

.edit{
    margin-left:20px;
    cursor:pointer;
}
.pagination{
    display:flex;
    gap:12px;
    align-items:center;
}

.arrow{
    display:flex;
    cursor:pointer;
}

.heading-text{
    color: #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; 
}

.page-details{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; 
}

.dots-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #DCDCDC;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: #DA6C74;   /* dark active dot */
  width: 10px;
  height: 10px;
}

`

const SliderContainerV1 = styled.div`
  width: 100%;

  .slick-slider {
    width: 100%;
    margin: ${({marginValue}) => marginValue ? marginValue : '20px 0 10px'};
    padding: ${({padding}) => padding ? padding : ''};
    box-shadow: none;

    .slick-slide{
      display: flex;
      justify-content: ${({ content }) => content ? content : 'center'};
      display: ${({display}) => display ? display : 'block'};
      margin: ${({margin}) => margin ? margin : ''};
      @media (max-width: 600px){
        margin: 0 auto;
      }
    }
    .slick-prev {
      display:none !important;
    } 
    .slick-track {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    margin-left: ${({ content }) => content ? "0 !important" : 'auto'};
    margin-right:${({ content }) => content ? "0 !important" : 'auto'};
    }
    

    .slick-next {
      display:none !important;
    }
      [dir="rtl"] .slick-next:before {
        content: "‹";
      }
       .slick-dots{
        li{
        margin:0px;
        }
        li button:before {
              font-size: 10px;
        }
         li:hover button:before{
           color: #DA6C74 !important;
         }
        li.slick-active button:before {
          opacity: 1;
          color: #DA6C74 !important;
        }
      }
  }

  .admin-top-four-cards{
    max-width:400px;
    .flex-item:not(:nth-child(4n)) {
  margin-right: 0;
}
&:nth-child(4n){
    margin-right: 0;
  }
  }

  .single-card{
    display:flex;
    max-width:400px;
    ${'' /* margin-right:25px; */}

    .flex-item:not(:nth-child(4n)) {
  margin-right: 0;
}
&:nth-child(4n){
    margin-right: 0;
  }
  }
`;

const SliderContainerV2 = styled.div`
  width: 100%;
  display:flex;


  .single-card{
    display:flex;
    max-width:400px;
    ${'' /* margin-right:12px; */}
    margin-right:${({mulitiPage}) => mulitiPage ? '12px' : '20px'};
    width:297px;

    .flex-item:not(:nth-child(4n)) {
        ${'' /* margin-right:${({mulitiPage}) => !mulitiPage && 0}; */}
        margin-right:0;
}
&:nth-child(4n){
    ${'' /* margin-right:${({mulitiPage}) => !mulitiPage && 0} */}
    margin-right:0;
  }
  }
`;

const ConfirmPlanModalBody = styled.div`
color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
display:flex;
${'' /* justify-content:center; */}
flex-direction:column;
align-items:center;

.plan-badge{
    margin:20px 0px;
}

.date-heading{
    margin:20px 0px 9px 0px;
}

.date{
    font-weight: 700;
}

.sub-heading{
    margin:20px 0;x;
}



`

const LevelIconContainer = styled.div`
border: 0.53px solid ${({ border }) => (border ? border : '#E5E7EB')};
background:${({bg}) => bg ? bg : '#8391D1'};
border-radius:50%;
display:flex;
justify-content:center;
align-items:center;
width:32px;
height:32px;
.image{

    >img{
        width:22px;
        
    }

}
` 

const PointsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);  /* 2 items per row */
  gap: 16px 24px; /* row gap | column gap */
  margin: 0 0 24px 0;
`;

const GridItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  color: #184A61;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  .level {
    font-weight: 700;
    text-transform:capitalize;
  }
`;



export {RewardsDashboard,ConfigureRewards,StyledModal,CalendarHeader,Border,Grid,Card,Header,Title,Badge,PointsList,Description, ButtonContainer, TierBody,CompanyMedalCardsSliderContainer, SliderContainerV1, SliderContainerV2,ConfirmPlanModalBody,LevelIconContainer, PointsGrid, GridItem}